import React from 'react';
import Select, { components } from 'react-select';
import PropTypes from 'prop-types';

import Error from './Error';

const Select2 = React.memo(
  ({
    label = '',
    placeholder = '',
    styles = {},
    error = '',
    options,
    initialValue = '',
    disabled,
    onChange,
    'data-testid': testId,
  }) => {
    const selectStyles = {
      control: base => ({
        ...base,
        height: '44px',
        boxShadow: 'inset 0 2px 2px 0 rgba(132, 130, 156, 0.2)',
        borderStyle: 'solid',
        borderWidth: '1px',
        '&:hover': {
          borderColor: '#80bdff',
        },
        ...styles,
      }),
    };

    return (
      <div className="form-group">
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label>{label}</label>
        <Select
          key={initialValue.toString()}
          className="basic-single"
          classNamePrefix="select"
          defaultValue={
            options &&
            options.filter(
              option => option.value.toString() === initialValue.toString(),
            )
          }
          isSearchable
          placeholder={placeholder}
          styles={selectStyles}
          options={options}
          isDisabled={disabled}
          components={{
            Input: props => (
              <components.Input {...props} data-testid={testId} />
            ),
          }}
          onChange={onChange}
        />
        <Error error={error} />
      </div>
    );
  },
);

Select2.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  styles: PropTypes.object,
  error: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
  initialValue: PropTypes.string,
};

export default Select2;
